import { RouteNames } from "../types/names";
import type { AppRouteRecordRaw } from "../types/types";

import { PERMISSIONS, USER_ROLES } from "@/shared/permissions";

const coreRoutes: AppRouteRecordRaw[] = [
  {
    path: "/organization",
    name: RouteNames.ORGANIZATION,
    component: () => import("@/pages/OrganizationPage.vue"),
    meta: {
      title: "Organization",
      menuOrder: 1,
      showInMenu: false,
    },
  },
  {
    path: "/organizations",
    name: RouteNames.ORGANIZATIONS,
    component: () => import("@/pages/OrganizationsPage.vue"),
    meta: {
      // ADMIN-only — organization management is restricted to super admins.
      // When new admin-tier roles are added, extend this array.
      roles: [USER_ROLES.ADMIN],
      title: "Organizations",
      menuTitle: "Organizations",
      menuIcon: "lucide:building-2",
      menuOrder: 2,
      showInMenu: true,
    },
  },
  {
    path: "/users",
    name: RouteNames.USERS,
    component: () => import("@/pages/UsersPage.vue"),
    meta: {
      permissions: [PERMISSIONS.USERS_READ],
      title: "Users",
      menuTitle: "Users",
      menuIcon: "lucide:users",
      menuOrder: 99,
      showInMenu: true,
    },
  },
  {
    path: "/users/:id",
    name: RouteNames.USER_DETAIL,
    component: () => import("@/pages/UserDetailPage.vue"),
    meta: {
      permissions: [PERMISSIONS.USERS_READ],
      title: "User Details",
      showInMenu: false,
    },
  },
  {
    path: "/profile",
    name: RouteNames.MY_PROFILE,
    component: () => import("@/pages/UserProfilePage.vue"),
    meta: {
      // No permission required — any authenticated user can view their own profile.
      title: "My Profile",
      showInMenu: false,
    },
  },
];

export default coreRoutes;
